import { LlmSubjectKind } from '../../utils/apollo/graphqlSchema';
import ExplainAnalysisWithAiPanel from './ExplainAnalysisWithAiPanel';
import { UnreachableCaseError } from 'ts-essentials';
import DummyExplainWithAiPanel from './DummyExplainWithAiPanel';
import { useParams } from 'react-router-dom';
import ExplainWithAiNotConfigured from './ExplainWithAiNotConfigured';
import { useBootstrapSelector } from '../../redux/selectorHooks';

interface IProps {
  subjectKind: LlmSubjectKind;
}

const ExplainEntityWithAiPanel = ({ subjectKind }: IProps) => {
  const params = useParams();
  const analysisId = params?.builderId ?? null;

  const llmApiEnabled = useBootstrapSelector('llmApiEnabled');

  if (!llmApiEnabled) {
    return <ExplainWithAiNotConfigured />;
  }

  if (!analysisId) {
    return <DummyExplainWithAiPanel subjectKind={subjectKind} />;
  }
  switch (subjectKind) {
    case LlmSubjectKind.Analysis:
      return <ExplainAnalysisWithAiPanel analysisId={analysisId} />;
    case LlmSubjectKind.Dashboard:
      // XXX Dashboard support plan abandoned for now.
      return <DummyExplainWithAiPanel subjectKind={subjectKind} />;
    default:
      throw new UnreachableCaseError(subjectKind);
  }
};

export default ExplainEntityWithAiPanel;
